import moment from 'moment';
export var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.prototype.format = function (date, format) {
        return moment(date.getTime()).format(format);
    };
    return DateFormatter;
}());
//# sourceMappingURL=date-formatter.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/node_modules/ng2-bootstrap/datepicker/date-formatter.js
// module id = ../../../../ng2-bootstrap/datepicker/date-formatter.js
// module chunks = vendor